/*==============================
*
* on vous guide
*
==============================*/

/*======
LIBRARY
======*/
global.Dropzone = require('dropzone');


/* OWL CAROUSEL FOR SLIDER */
require('owl.carousel');

// require('./partials/btn-mail-tel');

/*======
PAGES
======*/
require('./pages/on-vous-guide');

require('leaflet');
require('./partials/magasin-proximite');

/*======
GESTION MODALES 
======*/
require('./partials/modal-contact-magasin.js');
